'use client' // Error boundaries must be Client Components

import {MainLayoutPage} from "@/theme/mainLayout/mainLayoutPage";
import {ErrorPageComponent} from "@/components/errorPage";

export default function Error({ error, reset }) {
    return (
        <MainLayoutPage>
            <ErrorPageComponent />
        </MainLayoutPage>
    )
}